module.exports = __webpack_public_path__ + "img/qq.a0d0a1e4.png";